import { QuestionAnswerMap } from '@care-portals/api-interfaces';
import { IMAGE_TYPES } from '../../../../constants';

const questionsModels = [
  {
    field: 'hairlossPhotos_frontHeadPhoto',
    label: 'Please upload a clear photo of the front of your head',
    subLabel:
      'Take a clear photo of the front of your head, focusing on your hairline. Tilt your head slightly forward so the entire hairline area is clearly visible.',
    type: 'file_upload',
    accepts: IMAGE_TYPES,
    questionImage: 'assets/hairlossFrontHead.png',
    answer: [
      {
        resourceId: 'hairlossPhotos_frontHeadPhoto',
        buttonLabel: 'Front head photo'
      }
    ]
  },
  {
    field: 'hairlossPhotos_topOfScalp',
    label: 'Please upload a clear photo of the top of your scalp',
    subLabel:
      'Capture the top of your scalp from directly above. Make sure the full crown and surrounding area are clearly visible in the photo.',
    type: 'file_upload',
    accepts: IMAGE_TYPES,
    questionImage: 'assets/hairlossTopOfScalp.png',
    answer: [
      {
        resourceId: 'hairlossPhotos_topOfScalp',
        buttonLabel: 'Top of scalp photo'
      }
    ]
  },
  {
    field: 'hairlossPhotos_backOfHeadPhoto',
    label: 'Please upload a clear photo of the back of your head',
    subLabel:
      'Take a photo of the back of your head, focusing on the crown area. Ensure the circled area is centered and well lit so the thinning or density can be clearly seen.',
    type: 'file_upload',
    accepts: IMAGE_TYPES,
    questionImage: 'assets/hairlossBackOfHead.png',
    answer: [
      {
        resourceId: 'hairlossPhotos_backOfHeadPhoto',
        buttonLabel: 'Back of head photo'
      }
    ]
  },
  {
    field: 'hairlossPhotos_leftSideOfHeadPhoto',
    label: 'Please upload a clear photo of left side of your head',
    subLabel:
      'Take a photo of the left side of your head, showing the area from your hairline and temple down to your ear. Keep the full side area visible and well lit.',
    type: 'file_upload',
    accepts: IMAGE_TYPES,
    questionImage: 'assets/hairlossLeftSideOfHead.png',
    answer: [
      {
        resourceId: 'hairlossPhotos_leftSideOfHeadPhoto',
        buttonLabel: 'Left side photo'
      }
    ]
  },
  {
    field: 'hairlossPhotos_rightSideOfHeadPhoto',
    label: 'Please upload a clear photo of right side of your head',
    subLabel:
      'Take a photo of the right side of your head, showing the area from your hairline and temple down to your ear. Ensure the entire side is clearly visible and in focus.',
    type: 'file_upload',
    accepts: IMAGE_TYPES,
    questionImage: 'assets/hairlossRightSideOfHead.png',
    answer: [
      {
        resourceId: 'hairlossPhotos_rightSideOfHeadPhoto',
        buttonLabel: 'Right side photo'
      }
    ]
  }
] as const;

export type HairlossPhotoQuestionFieldAnswers = Partial<
  QuestionAnswerMap<typeof questionsModels>
>;

export default questionsModels;
